import styled from 'styled-components';

export const VivariumDetails = styled.div`

`
